import React from 'react';
import {View} from 'react-native';
import ProgressBar, {
  ProgressBarProps,
} from '@components/business/games/progress';
import {Times} from '@/components/business/games';
import {TabItem} from '../mix-lottery-service';
import theme from '@/style';

export interface QuickLotteryProps {
  lotteryID: number;
  tabs?: TabItem[];
  onTimeChange?: (id?: number) => void;
}

const QuickLottery = ({
  lotteryID,
  tabs = [],
  onTimeChange,
  value,
  total,
}: QuickLotteryProps & ProgressBarProps) => {
  const minutes = React.useMemo(() => {
    return tabs.map(item => {
      return {
        cycle: item.tabName,
        id: item.lotteryID,
      };
    });
  }, [tabs]);

  return (
    <>
      {minutes.length > 1 ? (
        <Times
          style={[theme.padding.lrxs, styles.timesWrap]}
          checkColors={['#B7AFAF', '#DACECE']}
          itemStyle={[theme.flex.row, styles.timeItem]}
          selectInnerStyle={styles.timeItemSelected}
          minutes={minutes}
          configId={lotteryID}
          onTimePress={onTimeChange}
        />
      ) : (
        <View />
      )}

      <ProgressBar value={value} total={total} />
    </>
  );
};

const styles = {
  timesWrap: {
    minHeight: 52,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    gap: 8,
  },
  timeItem: {
    height: 52,
    gap: 6,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  timeItemSelected: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
};

export default QuickLottery;
